type AuroraDefaultInput = {
  aurora_racking_type?: number | null;
  default_project_mode?: number | null;
};

// Pure defaults. Do not read the store here — this runs from reducers, and
// store.getState() during a reducer throws Redux error #3.
const aurora = (input: AuroraDefaultInput = {}) => {
  const auroraConfig = {
    building_code: 2,
    wind_speed: 115,
    snow_load: 5,
    seismic_ss: 0.46,
    elevation: 5499,
    mean_recurrence_interval: 25,
    building_height: 15,
    roof_type: 5,
    parapet_height: 1,
    block_weight: 32,
    wind_exposure: 'B',
    building_length: 100,
    aurora_racking_type: input.aurora_racking_type || 25,
    is_test: input.default_project_mode,
  };
  return auroraConfig;
};

export function applyAuroraDefaults<T extends object>(
  incoming: T,
  options: {
    defaultCfg?: ReturnType<typeof aurora> | null;
    currentRackingType?: number | null;
    base?: object;
  } = {},
) {
  const defaults = options.defaultCfg || aurora({
    aurora_racking_type: options.currentRackingType,
  });
  return {
    ...(options.base || {}),
    ...incoming,
    ...defaults,
  };
}

export default aurora;
